module.exports = __webpack_public_path__ + "static/tecnologia-d46446ba9ffd17f0ea470e1465db8593.png";